import React from 'react'
import ReactDOM from 'react-dom'
import LabelWithHelp from '../src/javascripts/label_with_help';
import ValidatedInput from '../src/javascripts/validated_input';
import * as yup from 'yup';

function VelocityVerdict(props) {
  let velocityEstimate = props.velocityEstimate;
  if (isNaN(velocityEstimate) || !isFinite(velocityEstimate)) {
    velocityEstimate = "--";
  }
  return (
    <React.Fragment>
      <h5 className="pt-2 text-uppercase text-center">Estimated Velocity</h5>
      <h5 className="mt-1 text-center">{ velocityEstimate.toLocaleString() }</h5>
    </React.Fragment>
  )
}

class VelocityEstimator extends React.Component {
  constructor(props) {
    super(props);
    this.handleVelocityAChange = this.handleVelocityAChange.bind(this);
    this.handleWeightAChange = this.handleWeightAChange.bind(this);
    this.handleWeightBChange = this.handleWeightBChange.bind(this);
    this.state = {
      velocityA: '',
      weightA: '',
      weightB: '',
      velocityAValidationError: null,
      weightAValidationError: null,
      weightBValidationError: null
    };

    this.schema = yup.object({
      velocityA: yup.number()
        .required('Velocity is required')
        .typeError('Velocity must be a number')
        .positive('Velocity must be a positive number'),
      weightA: yup.number()
        .required('Weight is required')
        .typeError('Weight must be a number')
        .positive('Weight must be a positive number'),
      weightB: yup.number()
        .required('Weight is required')
        .typeError('Weight must be a number')
        .positive('Weight must be a positive number')
    });

  }

  // validates single field, eg: input = {muzzleVelocity: muzzleVelocity}, and sets error message
  validateField(input) {
    const path = Object.keys(input)[0];
    const errorMessageKey = path + "ValidationError";
    yup.reach(this.schema, path).validate(input[path])
    .then(function(value) {
      this.setState({[errorMessageKey]: null});
    }.bind(this))
    .catch(function(error) {
      this.setState({[errorMessageKey]: error.message});
    }.bind(this));
  }

  handleVelocityAChange(velocityA) {
    this.validateField({velocityA: velocityA});
    this.setState({velocityA: velocityA});
  }
  handleWeightAChange(weightA) {
    this.validateField({weightA: weightA});
    this.setState({weightA: weightA});
  }
  handleWeightBChange(weightB) {
    this.validateField({weightB: weightB});
    this.setState({weightB: weightB});
  }

  estimate(knownVelocity, knownWeight, unknownWeight) {
    return Math.round(Math.pow((knownWeight * Math.pow(knownVelocity, 2.0) / unknownWeight), 0.5));
  }

  render() {
    const velocityA = this.state.velocityA;
    const weightA = this.state.weightA;
    const weightB = this.state.weightB;
    const velocityAValidationError = this.state.velocityAValidationError;
    const weightAValidationError = this.state.weightAValidationError;
    const weightBValidationError = this.state.weightBValidationError;

    return (
      <React.Fragment>
        <div className="row pb-3">
          <div className="col-lg-6 pt-3 d-flex flex-column">

            <h5 className="text-uppercase text-center">Known Bullet</h5>
            <div className="card bg-primary h-100">
              <div className="card-body">
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The weight of the bullet which has a known velocity">Weight</LabelWithHelp>
                  <ValidatedInput value={weightA} onValueChange={this.handleWeightAChange} validationErrorMessage={weightAValidationError}/>
                </div>
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The velocity of the bullet that you have measured">Velocity</LabelWithHelp>
                  <ValidatedInput value={velocityA} onValueChange={this.handleVelocityAChange} validationErrorMessage={velocityAValidationError}/>
                </div>
              </div>
            </div>

          </div>
          <div className="col-lg-6 pt-3 d-flex flex-column">

            <h5 className="text-uppercase text-center">Unknown Bullet</h5>
            <div className="card bg-primary h-100">
              <div className="card-body">
                <div className="form-group">
                  <LabelWithHelp tooltipContent="The weight of the bullet which has an unknown velocity">Weight</LabelWithHelp>
                  <ValidatedInput value={weightB} onValueChange={this.handleWeightBChange} validationErrorMessage={weightBValidationError}/>
                </div>
              </div>
              <div className="card-footer bg-secondary">
                <VelocityVerdict velocityEstimate={ this.estimate(velocityA, weightA, weightB) } />
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <VelocityEstimator />,
    document.getElementById('velocity_estimator')
  )
});
